import { ViperRangePicker } from "@/components";
import dayjs from "dayjs";
import { bool, object } from "prop-types";
import { useEffect, useState } from "react";
import { DynamicFormItem } from "./DynamicFormItem";
import { useDynamicFormContext } from "./DynamicFormProvider";
import { useCheckEditableFormField } from "./hooks/useCheckEditableFormField";

export const DynamicDateRangePicker = ({
  formField,
  formField: { includeTime, timeParentField, property, timeDependentValues },
  formDisabled,
}) => {
  const { isDisabled } = useCheckEditableFormField(formField);
  const { getDependentPropertyValue } = useDynamicFormContext();

  const [displayTime, setDisplayTime] = useState(false);

  useEffect(() => {
    const calculateShouldShowTime = () => {
      if (!formField || !includeTime) return;

      if (!timeParentField) {
        return true;
      }

      const timeParentFieldValue = getDependentPropertyValue(
        property.timeParentField
      );

      if (!timeParentFieldValue) {
        return false;
      }

      return (
        !timeDependentValues ||
        !timeDependentValues.length ||
        property.timeDependentValues.includes(timeParentFieldValue)
      );
    };

    setDisplayTime(calculateShouldShowTime());
  }, [
    formField,
    getDependentPropertyValue,
    includeTime,
    property.timeDependentValues,
    property.timeParentField,
    timeDependentValues,
    timeParentField,
  ]);

  const shouldShowBothDates = () => property.Name !== "Planned";

  const getValueProps = (value) => {
    const convertToDayJS = (val) => {
      if (val) return new dayjs(val);
    };

    if (!value?.length) return { value: [] };

    if (value.length > 1 && shouldShowBothDates())
      return {
        value: [convertToDayJS(value[0]), convertToDayJS(value[1])],
      };

    return { value: [convertToDayJS(value[0]), undefined] };
  };

  return (
    <DynamicFormItem formFieldProperty={property} getValueProps={getValueProps}>
      <ViperRangePicker
        id={`dynamic-date-range-picker-${property.name}`}
        disabled={formDisabled || isDisabled}
        showTime={displayTime ? { format: "HH:mm a", minuteStep: 30 } : false}
        allowEmpty={[true, true]}
      />
    </DynamicFormItem>
  );
};

DynamicDateRangePicker.propTypes = {
  formField: object.isRequired,
  formDisabled: bool,
};
